import events from "../store/utils/events.js";
import { NON_SCROLLABLE_PAGES } from '../config.js';
import { trackEvent } from '../store/utils/tracking';

export default {
    visitProduct(router, product, paramObject) {
        //Ensure productOptionValueId is set if it exists
        if (product.product_option_value_id) {
            paramObject.productOptionValueId = product.product_option_value_id;
        }
        if (paramObject.replaceRoute) {
            router.replace({path: '/products/' + product.product_id, query: paramObject});
        } else {
            events.trackEvent(
                'click_product',
                {
                    outfitId: paramObject?.outfitId || product.outfit_id,
                    outfitAltered: false,
                    originalProductId: product.product_id
                }
            );

            router.push({path: '/products/' + product.product_id, query: paramObject});
        }
    },
    visitUrl(router, url) {
        router.push({path: url});
    },
    scrollToLastSavedPosition(path) {
        if (window.lastSavedScrollPosition && window.lastSavedScrollPosition[path]) {
            const scrollableEl = window.document.querySelector('.allow-scrolling');
            const scrollOptions = window.lastSavedScrollPosition[path];
            if(!scrollableEl) return;
    
            scrollableEl.scrollTo(scrollOptions.x, scrollOptions.y);
        }
    },
    removeScrollingBehavior() {
        document.getElementById('main-wrapper').classList.remove('allow-scrolling');
    },
    addScrollingBehavior(path) {
        if(!path || !NON_SCROLLABLE_PAGES.some(page => path.includes(page))){
            document.getElementById('main-wrapper').classList.add('allow-scrolling');
        }
    },
    trackEvent,
}